import Banner from '../../../../../banner/banner';

/**
 * Grille d'informations utilisateur (Nom, Prénom, Date de naissance)
 * @param {object} props
 * @param {object} props.user - Les données de l'utilisateur
 * @param {string} props.validationStatus - Statut de validation ('1', '2', '3')
 * @param {boolean} props.showBirthday - Afficher la date de naissance (défaut: true)
 * @param {boolean} props.showNationality - Afficher la nationalité
 * @param {string} props.nationalityText - Texte de la nationalité
 * @param {React.ReactNode} props.additionalBanner - Banner supplémentaire à afficher
 * @param {React.ReactNode} props.children - Contenu additionnel
 */
const UserInfoGrid = ({ 
  user, 
  validationStatus,
  showBirthday = true,
  showNationality = false,
  nationalityText = '',
  additionalBanner = null,
  children 
}) => {
  return (
    <div className="w-full py-3">
      <div className="grid grid-cols-2 gap-4 ft-sm">
        {validationStatus === '2' && (
          <div className="col-span-2">
            <Banner type="info">Le document est validé.</Banner>
          </div>
        )}
        {validationStatus === '3' && (
          <div className="col-span-2">
            <Banner type="alert">
              Le document a été refusé. Le candidat a déjà été notifié.
            </Banner>
          </div>
        )}
        {additionalBanner}
        
        <div>Nom</div>
        <div className="text-gray-500">{user?.lastname}</div>
        
        <div>Prénom</div>
        <div className="text-gray-500">{user?.firstname}</div>
        
        {showBirthday && (
          <>
            <div>Date de naissance</div>
            <div className="text-gray-500">{user?.birthday}</div>
          </>
        )}
        
        {showNationality && (
          <>
            <div>Nationalité</div>
            <div className="text-gray-500">{nationalityText}</div>
          </>
        )}
        
        {children}
      </div>
    </div>
  );
};

export default UserInfoGrid;
